import { Form, Formik } from 'formik'
import React, { useEffect, useRef, useState } from 'react'
import { PaymentSetInformationSchema } from '../../../common/validators/paymentSetInformationSchema';
import FormObserver from '../FormElements/FormObserver';
import { FormCheckbox, FormInput, FormSelector } from '../FormElements';
import commonNetwork from '../../../common/api/commonNetwork';
import { toast } from 'react-toastify';
import FormMultiSelect from '../FormElements/FormMultiSelect';
import { Button } from '../Elements';
import { useNavigate } from 'react-router-dom';
import SetVpTable from './SetVpTable';
import { FormControlLabel, Switch } from '@mui/material';
import { useSelector } from 'react-redux';
import { PaymentSetProps } from '../../pages/InsertUpdatePaymentSet';

type PaymentSetInformationProps = {
    formValues: PaymentSetProps;
    setFormValues: any;
    setIsPaymentSetSaved: any;
    setTabIndex: any;
    paymentSetId: number;
}

const PaymentSetInformations: React.FC<PaymentSetInformationProps> = ({ formValues, setFormValues, setIsPaymentSetSaved, setTabIndex, paymentSetId }) => {

    const navigate = useNavigate();
    const navbarState = useSelector((state: any) => state.navbar);
    const sideBarOpen = navbarState.isOpen;

    const tableSelectedRows = useRef<any>(null);

    const [activePosList, setActivePosList] = useState<any[]>([]);
    const [isLoading, setIsLoading] = useState<boolean>(false);

    useEffect(() => {
        selectActivePos();
    }, []);

    const onSubmit = async () => {
        const selected = await tableSelectedRows.current.getSelectedRows();
        setFormValues((prevValues: any) => ({
            ...prevValues,
            vpList: selected,
        }));
        
        if (selected.length < 1) {
            toast.error("Pos Seçiniz!");
        } else {
            setIsPaymentSetSaved(true);
            setTabIndex("2");
        }
    }

    const selectActivePos = async () => {

        const data = await commonNetwork.get("/virtualpos/actives");
        if (data.isSuccess) {
            setActivePosList(data.data);
        } else {
            toast.error(data.errorMessage);
        }
    }

    return (
        <div className='w-full flex flex-col'>
            <div className='flex flex-col items-center justify-center'>
                <Formik
                    initialValues={formValues}
                    enableReinitialize
                    validationSchema={PaymentSetInformationSchema}
                    onSubmit={onSubmit}
                >
                    {({
                        values,
                        setFieldValue,
                        errors                          
                    }) => (
                        <>
                            <Form className="w-full">
                                <FormObserver
                                    watch={(val: any) => {
                                        setFormValues(val);
                                    }}
                                />
                                <div className='m-4 p-4 bg-white shadow-md rounded-md'>
                                    <div className='flex flex-row justify-start'>
                                        <span className='font-bold text-contrast-90'>
                                            Genel Parametreler
                                        </span>
                                    </div>
                                    <div className='grid grid-cols-1 gap-4 sm:gap-6 lg:grid-cols-4 xl:grid-cols-4 mt-3 mb-3'>
                                        <div className="col-span-2 mt-3 space-y-2">
                                            <FormInput
                                                label="Ödeme Kuralı Açıklaması"
                                                name="paymentSetDesc"
                                                type="text"
                                                value={values.paymentSetDesc}
                                            />
                                        </div>
                                        <div className='col-span-2 mt-8 space-y-2'>
                                            <FormControlLabel
                                                className={`flex flex-row justify-end font-small ${formValues.status == true ? "text-success-blue" : "text-gray-400"}`}
                                                style={{
                                                    marginRight: 0,
                                                    marginLeft: -10,
                                                }}
                                                label={<p >{formValues.status ? "Aktif" : "Pasif"}</p>}
                                                control={
                                                    <Switch
                                                        style={{
                                                            marginRight: 0,
                                                        }}
                                                        defaultChecked={formValues.status}
                                                        checked={formValues.status}
                                                        onChange={(e) => {
                                                            setFormValues((prevValues: any) => ({
                                                                ...prevValues,
                                                                status: !formValues.status
                                                            }))
                                                        }}
                                                    />
                                                }>
                                            </FormControlLabel>
                                        </div>
                                    </div>
                                </div>
                                <SetVpTable activePostList={activePosList} tableSelectedRows={tableSelectedRows} formValues={formValues} />
                                <div className={`w-full  bottom-button-fixed ${sideBarOpen ? " openedmenu-width" : " closedmenu-width"}`} >
                                    <div className="ml-0 flex flex-row justify-end bg-white shadow-md">
                                        <div className="m-4  p-0 space-x-4 flex flex-row">
                                            <Button
                                                type="button"
                                                size="lg"
                                                color="gray"
                                                hover="gray"
                                                callback={() => {
                                                    navigate(-1);
                                                }}
                                            >
                                                Geri Dön
                                            </Button>
                                            <Button
                                                size="lg"
                                                color="primary"
                                                hover="primary"
                                                spanClass={"ml-1.5 mr-1.5 "}
                                                loading={isLoading}
                                                type="submit"
                                            >
                                                İleri
                                            </Button>

                                        </div>
                                    </div>
                                </div>
                            </Form>
                        </>
                    )}
                </Formik>
            </div>
        </div>
    )
}

export default PaymentSetInformations;